// extracted by mini-css-extract-plugin
export default {"container":"TeamLayout_container__Qsgtv","body":"TeamLayout_body__CAfgS","main":"TeamLayout_main__Voe7c","chapterBtn":"TeamLayout_chapterBtn__5b81q"};